import { IItem } from "./items";

export interface IDocumentAlert {
  detectedItem: IItem;
  kind: string;
  target: string;
  description: string;
  isError: boolean;
  itemSetId: number;
  isConfirmDenied?: boolean;
}

export function instanceOfIDocumentAlert(instance: any): instance is IDocumentAlert {
  return instance
      && (instance.detectedItem !== undefined)
      && (instance.kind !== undefined)
      && (instance.target !== undefined)
      && (instance.description !== undefined)
      && (instance.isError !== undefined)
      && (instance.itemSetId !== undefined);
}
